<div class="container py-5" style="max-width: 520px;">
  <div class="text-center mb-4">
    <h2 class="fw-bold mb-1">Change Password</h2>
    <div class="text-muted">Choose a strong password you do not use on another service</div>
  </div>

  <div *ngIf="error" class="alert alert-danger" role="alert">{{ error }}</div>
  <div *ngIf="success" class="alert alert-success" role="alert">{{ success }}</div>

  <form class="card shadow-sm" [formGroup]="form" (ngSubmit)="submit()">
    <div class="card-body p-4">
      <div class="mb-3">
        <label class="form-label">Current password</label>
        <input
          type="password"
          class="form-control"
          formControlName="currentPassword"
          [class.is-invalid]="submitted && form.controls.currentPassword.invalid"
        />
        <div class="invalid-feedback">Current password is required.</div>
      </div>

      <div class="mb-3">
        <label class="form-label">New password</label>
        <input
          type="password"
          class="form-control"
          formControlName="newPassword"
          [class.is-invalid]="submitted && form.controls.newPassword.invalid"
        />
        <div class="invalid-feedback">Use at least 8 characters with uppercase, lowercase, number, and special character.</div>
      </div>

      <div class="mb-2">
        <label class="form-label">Confirm new password</label>
        <input
          type="password"
          class="form-control"
          formControlName="confirmPassword"
          [class.is-invalid]="submitted && form.controls.confirmPassword.invalid"
        />
        <div class="invalid-feedback">Please confirm your new password.</div>
      </div>

      <button class="btn btn-primary w-100 mt-3" type="submit" [disabled]="loading">
        <span *ngIf="!loading">Update Password</span>
        <span *ngIf="loading">Updating...</span>
      </button>

      <div class="text-center mt-3">
        <a routerLink="/account/security" class="text-decoration-none">Back to account security</a>
      </div>
    </div>
  </form>
</div>